class VariantRadiosMetafield extends VariantRadios {
	constructor() {
		super();
	}

	// 覆写 1：彻底禁用旧版的滑动逻辑。
	// 因为基于 Metafield 方案，每次切换变体都要完全重建 DOM，滑动旧 DOM 是无意义的。
	updateMedia() {
		// 留空，阻断父类行为
		return;
	}

	// 覆写 2：执行 DOM 替换
	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		// 触发原始的数据拉取请求
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`
		)
			.then((response) => response.text())
			.then((responseText) => {
                if (this.currentVariant?.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, 'text/html');
				
				// 1. 替换主图和缩略图 DOM
				const mediaSource = html.querySelector(
					`[data-section="product-media-${sectionId}"]`
				);
				const mediaDestination = document.querySelector(
					`[data-section="product-media-${this.dataset.section}"]`
				);

				if (mediaSource && mediaDestination) {
					mediaDestination.innerHTML = mediaSource.innerHTML;
				}

				// 2. 【新增】替换放大弹窗 DOM
				// 根据你提供的弹窗代码，它的 ID 是 ProductModal-{section.id}
				const modalSource = html.querySelector(
					`#ProductModal-${sectionId}`
				);
				const modalDestination = document.querySelector(
					`#ProductModal-${this.dataset.section}`
				);

				if (modalSource && modalDestination) {
					modalDestination.replaceWith(modalSource);
				}

				// 3. 【更新】重新初始化所有轮播图实例，包括弹窗
				if (typeof subSliderInit === 'function') subSliderInit(true);
				if (typeof sliderInit === 'function') sliderInit(true);
				// 必须调用 update-slider.js 中定义的弹窗初始化方法
				if (typeof popupSliderInit === 'function') popupSliderInit(true);
				// 4. 【新增】重新绑定放大十字星和点击放大事件
				if (typeof window.initZoomImage === 'function') window.initZoomImage();
				if (typeof window.initCustomCursor === 'function') window.initCustomCursor();
			});
			
		// 调用父类的 renderProductInfo 来处理价格、SKU更新
		super.renderProductInfo(); 
	}
}

// 注册新的自定义元素
customElements.define('variant-radios-metafield', VariantRadiosMetafield);